<template>
  <div>
    <v-btn
      rounded="lg"
      prepend-icon="mdi-account-key"
      block
      class="gradient-color-primary"
      @click="openBetaAccessDialog"
    >
      Betazugänge verwalten
    </v-btn>
  </div>
  <v-dialog
    class="beta-dialog"
    v-model="betaAccessDialog"
    max-width="500"
    persistent
  >
    <v-card class="beta-card" rounded="lg">
      <v-card-title class="beta-header">
        <span class="headline">Betazugänge verwalten</span>
      </v-card-title>
      <v-divider class="beta-divider"></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-checkbox
              color="green"
              v-model="agencyBetaAccess"
              label="Betazugang"
              hide-details
              density="comfortable"
              @change="changeBetaAccessAndSaveLog"
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              color="green"
              v-model="agencyWhatsAppAccess"
              label="WhatsApp Zugang"
              hide-details
              density="comfortable"
              @change="changeWhatsAppAccessAndSaveLog"
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              color="green"
              v-model="agencyPortalBuilderAccess"
              label="Portal Builder Zugang"
              hide-details
              density="comfortable"
              @change="changePortalBuilderAccessAndSaveLog"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" class="text-none" @click="betaAccessDialog = false"
          >Schließen</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    agency: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      betaAccessDialog: false,
      agencyBetaAccess: this.agency.style.betaAccess,
      agencyWhatsAppAccess: this.agency.style.whatsAppAccess,
      agencyPortalBuilderAccess: this.agency.style.portalBuilderAccess,
    };
  },
  methods: {
    ...mapActions("agency", [
      "changeBetaAccess",
      "saveLog",
      "changeWhatsAppAccess",
      "changePortalBuilderAccess",
    ]),
    async openBetaAccessDialog() {
      this.betaAccessDialog = true;
    },
    async changeBetaAccessAndSaveLog() {
      const betaAccess = !this.agency.style.betaAccess;
      const updatedAgency = await this.$store.dispatch(
        "agency/changeBetaAccess",
        { agencyId: this.agency._id, betaAccess }
      );
      if (updatedAgency) {
        await this.$store.dispatch("agency/saveLog", {
          agencyId: this.agency._id,
          changes: [
            {
              date: new Date(),
              description: `Beta access ${betaAccess ? "granted" : "revoked"}.`,
              user: this.$store.state.loginAndOut.name, // Fetch the name of the admin from the state
            },
          ],
        });
      }
    },
    async changeWhatsAppAccessAndSaveLog() {
      const whatsAppAccess = !this.agency.style.whatsAppAccess;
      const updatedAgency = await this.$store.dispatch(
        "agency/changeWhatsAppAccess",
        { agencyId: this.agency._id, whatsAppAccess }
      );
      if (updatedAgency) {
        await this.$store.dispatch("agency/saveLog", {
          agencyId: this.agency._id,
          changes: [
            {
              date: new Date(),
              description: `WhatsApp access ${
                whatsAppAccess ? "granted" : "revoked"
              }.`,
              user: this.$store.state.loginAndOut.name, // Fetch the name of the admin from the state
            },
          ],
        });
      }
    },
    async changePortalBuilderAccessAndSaveLog() {
      const portalBuilderAccess = !this.agency.style.portalBuilderAccess;
      const updatedAgency = await this.$store.dispatch(
        "agency/changePortalBuilderAccess",
        { agencyId: this.agency._id, portalBuilderAccess }
      );
      if (updatedAgency) {
        await this.$store.dispatch("agency/saveLog", {
          agencyId: this.agency._id,
          changes: [
            {
              date: new Date(),
              description: `Portal Builder access ${
                portalBuilderAccess ? "granted" : "revoked"
              }.`,
              user: this.$store.state.loginAndOut.name, // Fetch the name of the admin from the state
            },
          ],
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.beta-dialog {
  max-width: 600px;
  margin: 0 auto;
}

.beta-card {
  padding: 12px;
}

.beta-divider {
  margin: 12px 0;
}

</style>

